var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMinus = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.19999 13.143H16.8V10.8572H7.19999V13.143ZM12 21.143C6.7056 21.143 2.40001 17.0413 2.40001 12.0001C2.40001 6.95782 6.7056 2.85725 12 2.85725C17.2932 2.85725 21.6 6.95782 21.6 12.0001C21.6 17.0413 17.2932 21.143 12 21.143ZM12 0.571533C5.3724 0.571533 0 5.68811 0 12.0001C0 18.3121 5.3724 23.4287 12 23.4287C18.6264 23.4287 24 18.3121 24 12.0001C24 5.68811 18.6264 0.571533 12 0.571533Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMinus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_minus.55a9afd3bbb7f4855b655e5cd3762738.svg";